import axiosInstance from '../../../config/axiosInstance';
const StockBOMService = {
    async GetAllStockBoms(redirectCallback, StockID) {
        try {
            const response = await axiosInstance.get(`/Part/GetPartBOM?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteStockBom(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeletePartBOM?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async UpdateQuantity(PK_BOM_ID, updatedQuantity) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/UpdateStockBOMQuantity?BOMID=${PK_BOM_ID}&Quantity=${updatedQuantity}`);
           return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async BuildBOM(formData) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.post(`/Part/BuildBOM`, formData);
            return response.data.message;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default StockBOMService;